import { render, staticRenderFns } from "./StatementsTable.vue?vue&type=template&id=37f56538"
import script from "./StatementsTable.vue?vue&type=script&lang=js"
export * from "./StatementsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37f56538')) {
      api.createRecord('37f56538', component.options)
    } else {
      api.reload('37f56538', component.options)
    }
    module.hot.accept("./StatementsTable.vue?vue&type=template&id=37f56538", function () {
      api.rerender('37f56538', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Statements/StatementsTable.vue"
export default component.exports